export default __webpack_public_path__ + "static/media/tile004.653a7d12.png";